import { Reducer } from 'redux';
import { EstoqueState, EstoqueTypes } from './types';

const INITIAL_STATE: EstoqueState = {
  data: [],
  error: false,
  loading: false,
  loadingDetalhes: false,
  filter: undefined,
  sorter: undefined,
  codParceiro: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<EstoqueState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EstoqueTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EstoqueTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case EstoqueTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case EstoqueTypes.FILTER_ESTOQUE:
      return {
        ...state,
        filter: action.payload.filter,
      }; 
      case EstoqueTypes.SORTER_ESTOQUE:
        return {
          ...state,
          sorter: action.payload.sorter,
        };
      case EstoqueTypes.COD_PARCEIRO:
        return {
          ...state,
          codParceiro: action.payload.codParceiro,
        }; 
    case EstoqueTypes.CLEAN_ESTOQUE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
